import { useAssetStore } from '@pidz/stores';

export const fileRemove = (assets: Asset[]): void => {
  const assetStore = useAssetStore();

  assets.forEach((asset) => {
    if (asset.id) assetStore.removeAsset(asset.id);
  });
};